import {Component, OnChanges, OnInit} from '@angular/core';
import {TruckFormService} from '../../services/truck-form/truck-form.service';
import Tco from '../../models/tco';
import {
  ArcElement,
  BarController,
  BarElement,
  BubbleController,
  CategoryScale,
  Chart,
  DoughnutController,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  LogarithmicScale,
  PieController,
  PointElement,
  PolarAreaController,
  RadarController,
  RadialLinearScale,
  ScatterController,
  TimeScale,
  TimeSeriesScale,
  Title,
  Tooltip
} from 'chart.js';
import {UpdateMode} from '@angular/compiler-cli/src/ngtsc/typecheck/api';

Chart.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Filler,
  Legend,
  Title,
  Tooltip
);

@Component({
  selector: 'app-tco',
  templateUrl: './tco.component.html',
  styleUrls: ['./tco.component.scss']
})
export class TcoComponent implements OnInit {

  private _showComponent = false;
  private _dieselTco: Tco;
  private _electricTco: Tco;
  private _hydrogenTco: Tco;
  private tcoChart: Chart | null;


  get showComponent(): boolean {
    return this._showComponent;
  }

  get dieselTco(): Tco {
    return this._dieselTco;
  }

  get electricTco(): Tco {
    return this._electricTco;
  }

  get hydrogenTco(): Tco {
    return this._hydrogenTco;
  }


  constructor(private truckFormService: TruckFormService) {
    const initialTco = new Tco(0, 0, 0, 0, 0, 0, 0, 0,
      0, [], [], [], []);
    this._dieselTco = initialTco;
    this._electricTco = initialTco;
    this._hydrogenTco = initialTco;
    this.tcoChart = null;
  }

  ngOnInit(): void {

    this.truckFormService.dieselTcoSourceMessage.subscribe(tco => {
      this._showComponent = true;
      this._dieselTco = tco;
    });
    this.truckFormService.electricTcoSourceMessage.subscribe(tco => this._electricTco = tco);
    this.truckFormService.hydrogenTcoSourceMessage.subscribe(tco => {
      this._hydrogenTco = tco;
      this.updateChart();
    });

    const initialData = [2, 1, 3];

    this.tcoChart = new Chart('tco-chart', {
      type: 'bar',
      data: {
        labels: ['Camión Diesel', 'Camión Eléctrico', 'Camión Hidrógeno'],
        datasets: [
          {
            label: 'Precio Vehículo',
            data: initialData,
            backgroundColor: 'rgb(255, 0, 0)'
          },
          {
            label: 'Combustible',
            data: initialData,
            backgroundColor: 'rgb(54, 162, 235)'
          },
          {
            label: 'Mantenimiento',
            data: initialData,
            backgroundColor: 'rgb(0, 255, 0)'
          },
          {
            label: 'Seguro',
            data: initialData,
            backgroundColor: 'rgb(255,255,0)'
          },
          {
            label: 'Patente',
            data: initialData,
            backgroundColor: '#add8e6'
          },
          {
            label: 'Estación de Carga',
            data: initialData,
            backgroundColor: 'rgb(128,128,128)'
          }
        ]
      },
      options: {
        indexAxis: 'y',
        plugins: {
          title: {
            display: true,
            text: 'Comparativa TCO'
          }
        },
        responsive: true,
        scales: {
          x: {
            stacked: true
          },
          y: {
            beginAtZero: true,
            stacked: true
          }
        }
      },
    });
  }

  updateChart(): void {
    if (this.tcoChart == null) {
      return;
    }
    this.tcoChart.data.datasets[0].data = [this._dieselTco.vehiclePrice, this._electricTco.vehiclePrice, this._hydrogenTco.vehiclePrice];
    this.tcoChart.data.datasets[1].data = [this._dieselTco.fuel, this._electricTco.fuel, this._hydrogenTco.fuel];
    this.tcoChart.data.datasets[2].data = [this._dieselTco.maintenance, this._electricTco.maintenance, this._hydrogenTco.maintenance];
    this.tcoChart.data.datasets[3].data = [this._dieselTco.insurance, this._electricTco.insurance, this._hydrogenTco.insurance];
    this.tcoChart.data.datasets[4].data = [this._dieselTco.patent, this._electricTco.patent, this._hydrogenTco.patent];
    this.tcoChart.data.datasets[5].data = [this._dieselTco.infrastructure, this._electricTco.infrastructure,
      this._hydrogenTco.infrastructure];
    this.tcoChart.update();
  }
}
